const EPD = {
	banner: [{
		tips:'什么是EPD/CFP？',
		title:'EPD',
		content:'EPD指环境产品声明（Environmental Product Declaration），是提供基于预设参数的量化环境数据的环境声明，必要时包括附加环境信息。',
		img:require('@/assets/img/index/EPD_2x.png'),
		url: require('@/assets/img/index/banner01.png')
	},
	{
		tips:'什么是EPD/CFP？',
		title:'CFP',
		content:'CFP指产品碳足迹（Carbon Footprint Of A Product），是产品系统中的温室气体排放量和温室气体去除量之和，以二氧化碳当量为单位表示，基于使用气候变化单一影响类别的生命周期评价。',
		img:require('@/assets/img/index/CFP_2x.png'),
		url: require('@/assets/img/index/banner01.png')
	}],
	portal:'申请EPD/CFP',
	seach:'搜索已公告的EPD/CFP'
}


export default EPD